"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _layout = _interopRequireDefault(require("@clayui/layout"));

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["children", "onlySearch", "showMobile"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Search = function Search(_ref) {
  var children = _ref.children,
      onlySearch = _ref.onlySearch,
      showMobile = _ref.showMobile,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var content = /*#__PURE__*/_react.default.createElement("form", _extends({}, otherProps, {
    role: "search"
  }), children);

  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('navbar-form navbar-form-autofit', {
      'navbar-overlay navbar-overlay-sm-down': !onlySearch,
      show: showMobile
    })
  }, onlySearch ? content : /*#__PURE__*/_react.default.createElement(_layout.default.ContainerFluid, null, content));
};

var _default = Search;
exports.default = _default;